export interface LocaleConfig {
    [key: string]: {
        en: string;
        bg: string;
    }
}


export const Config = {
    "Home": {
        en: "Home",
        bg: "Начална страница"
    },
    "Payments": {
        en: "Payments",
        bg: "Плащания"
    },
    "All policies": {
        en: "All policies",
        bg: "Полици"
    },
    "Claims": {
        en: "Claims",
        bg: "Щети"
    },
    "Settings": {
        en: "Settings",
        bg: "Настройки"
    },
    "Total amount of payment": {
        en: "Total amount of payment",
        bg: "[bg]Total amount of payment"
    },
    "For selected instalments": {
        en: "For selected instalments",
        bg: "[bg]For selected instalments"
    },
    "Search Policy": {
        en: "Search Policy",
        bg: "[bg]Search Policy"
    },
    "Instalments": {
        en: "Instalments",
        bg: "[bg]Instalments"
    },
    "Delivery": {
        en: "Delivery",
        bg: "[bg]Delivery"
    },
    "Summary": {
        en: "Summary",
        bg: "[bg]Summary"
    },
    "Payment": {
        en: "Payment",
        bg: "[bg]Payment"
    },
    "Instalment": {
        en: "Instalment",
        bg: "[bg]Instalment"
    },
    "Due date": {
        en: "Due date",
        bg: "[bg]Due date"
    },
    "Status": {
        en: "Status",
        bg: "[bg]Status"
    },
    "Amount": {
        en: "Amount",
        bg: "[bg]Amount"
    },
    "Currency": {
        en: "Currency",
        bg: "[bg]Currency"
    },
    "Insured People": {
        en: "Insured People",
        bg: "[bg]Insured People"
    },
    "Trip Details": {
        en: "Trip Details",
        bg: "[bg]Trip Details"
    },
    "Covers": {
        en: "Covers",
        bg: "[bg]Covers"
    },
    "Additional Covers": {
        en: "Additional Covers",
        bg: "[bg]Additional Covers"
    },
    "Insuring Party": {
        en: "Insuring Party",
        bg: "[bg]Insuring Party"
    },
    "Contact Details": {
        en: "Contact Details",
        bg: "[bg]Contact Details"
    },
    "Up to 16 years old": {
        en: "Up to 16 years old",
        bg: "[bg]Up to 16 years old"
    },
    "16 to 65 years of age": {
        en: "16 to 65 years of age",
        bg: "[bg]16 to 65 years of age"
    },
    "65 to 70 years of age": {
        en: "65 to 70 years of age",
        bg: "[bg]65 to 70 years of age"
    },
    "Your changes has been made from other devices/browsers and if you would like to proceed further.": {
        en: "Your changes has been made from other devices/browsers and if you would like to proceed further.",
        bg: "[bg]Your changes has been made from other devices/browsers and if you would like to proceed further."
    },
    "Back":{
        en:"Back",
        bg:"[bg]Back"
    },
    "Cancel":{
        en:"Cancel",
        bg:"[bg]Cancel"
    },
    "Continue":{
        en:"Continue",
        bg:"[bg]Continue"
    },
    "close":{
        en:"close",
        bg:"[bg]close"
    },
    "delete":{
        en:"delete",
        bg:"[bg]delete"
    },
    "Email Sent Successfully":{
        en:"Email Sent Successfully",
        bg:"[bg]Email Sent Successfully"
    },
    "Vehicle": {
        en: "Vehicle",
        bg: "[bg]Vehicle"
    },
    "Policy Details": {
        en: "Policy Details",
        bg: "[bg]Policy Details"
    },
    "Personal info": {
        en: "Personal info",
        bg: "[bg]Personal info"
    },
    "Company Details": {
        en: "Company Details",
        bg: "[bg]Company Details"
    },
    "People": {
        en: "People",
        bg: "[bg]People"
    },
    "Person": {
        en: "Person",
        bg: "[bg]Person"
    },
    "to": {
        en: "to",
        bg: "[bg]to"
    },
    "You have no": {
        en: "You have no",
        bg: "[bg]You have no"
    },
    "Vehicle Owner": {
        en: "Vehicle Owner",
        bg: "[bg]Vehicle Owner"
    },
    "Talon": {
        en: "Talon",
        bg: "[bg]Talon"
    },
    "Description of the additional cover here":{
        en: "Description of the additional cover here",
        bg: "[bg]Description of the additional cover here" 
    },
    "Please check the owner/insuring party data": {
        en: "Please check the owner/insuring party data",
        bg: "[bg]Please check the owner/insuring party data"       
    },
    "Select a Vehicle":{
        en: "Select a Vehicle",
        bg: "[bg]Select a Vehicle"        
    },
    "New Vehicle": {
        en: "New Vehicle",
        bg: "[bg]New Vehicle"
    },
    "Enter new vehicle details below": {
        en: "Enter new vehicle details below",
        bg: "[bg]Enter new vehicle details below"
    },
    "No Due Instalments": {
        en: "No Due Instalments",
        bg: "[bg]No Due Instalments"
    },
    "Payment Successful":{
        en: "Payment Successful",
        bg: "[bg]Payment Successful"
    },
    "Policy Created": {
        en: "Policy Created",
        bg: "[bg]Policy Created"
    },
    "Go to home page": {
        en: "Go to home page",
        bg: "[bg]Go to home page"       
    },
    "Payment Failed": {
        en: "Payment Failed",
        bg: "[bg]Payment Failed"         
    },
    "Change Payment Method": {
        en: "Change Payment Method",
        bg: "[bg]Change Payment Method"     
    },
    "Contact Support": {
        en: "Contact Support",
        bg: "[bg]Contact Support"     
    },
    "Complete profile":{
        en: "Complete profile",
        bg: "[bg]Complete profile"          
    },
    "Your MTPL policy was successfully created and sent to your email": {
        en: "Your MTPL policy was successfully created and sent to your email",
        bg: "[bg]Your MTPL policy was successfully created and sent to your email"       
    },
    "We created your profile automatically. You can complete it right away": {
        en: "We created your profile automatically. You can complete it right away",
        bg: "[bg]We created your profile automatically. You can complete it right away"       
    },
    "Your Standard travel insurance policy was successfully created and sent to your email'": {
        en: "Your Standard travel insurance policy was successfully created and sent to your email'",
        bg: "[bg]Your Standard travel insurance policy was successfully created and sent to your email'"       
    },
    "Your payment could not be processed":{
        en:"Your payment could not be processed",
        bg:"[bg] Your payment could not be processed"
    },
    "Please consider paying with another payment method.":{
        en:"Please consider paying with another payment method.",
        bg:"[bg]Please consider paying with another payment method."
    },
    "We couldn’t charge your ePay account":{
        en:"We couldn’t charge your ePay account",
        bg:"[bg]We couldn’t charge your ePay account"
    },
    "Due Instalments": {
        en: "Due Instalments",
        bg: "[bg]Due Instalments"
    },
    "Billing history": {
        en: "Billing history",
        bg: "[bg]Billing history"
    },
    "Search for policy": {
        en: "Search for policy",
        bg: "[bg]Search for policy"
    },
    "Active": {
        en: "Active",
        bg: "[bg]Active"
    },
    "Archive": {
        en: "Archive",
        bg: "[bg]Archive"
    },
    "Draft": {
        en: "Draft",
        bg: "[bg]Draft"
    },
    "Personal Data": {
        en: "Personal Data",
        bg: "[bg]Personal Data"
    },
    "Insurance Objects": {
        en: "Insurance Objects",
        bg: "[bg]Insurance Objects"
    },
    "Delivery Addresses": {
        en: "Delivery Addresses",
        bg: "[bg]Delivery Addresses"
    },
    "Account Settings": {
        en: "Account Settings",
        bg: "[bg]Account Settings"
    },
    "Password": {
        en: "Password",
        bg: "[bg]Password"
    },
    "Notifications": {
        en: "Notifications",
        bg: "[bg]Notifications"
    },
    "Profile": {
        en: "Profile",
        bg: "[bg]Profile"
    },
    "Account": {
        en: "Account",
        bg: "[bg]Account"
    },
    "Vehicles": {
        en: "Vehicles",
        bg: "[bg]Vehicles"
    },
    "Property": {
        en: "Property",
        bg: "[bg]Property"
    },
    "Create new": {
        en: "Create new",
        bg: "[bg]Create new"      
    },
    "MTPL": {
        en: "MTPL",
        bg: "[bg]MTPL"
    },
    "MTPL Insurance": {
        en: "MTPL Insurance",
        bg: "[bg]MTPL Insurance"
    },
    "Property Insurance": {
        en: "Property Insurance",
        bg: "[bg]Property Insurance"
    },
    "Travel Insurance": {
        en: "Travel Insurance",
        bg: "[bg]Travel Insurance"
    },
    "Expires on": {
        en: "Expires on",
        bg: "[bg]Expires on"       
    },
    "Expired at":{
        en: "Expired at",
        bg: "[bg]Expired at"       
    },
    "Policies":{
        en:"Policies",
        bg:"[bg]Policies"
    },
    "Download":{
        en:"Download",
        bg:"[bg]Download"
    },
    "Paid date":{
        en:"Paid date",
        bg:"[bg]Paid date"
    },
    "Your policy will be expiring soon. Renew your policy now.":{
        en:"Your policy will be expiring soon. Renew your policy now.",
        bg:"[bg]Your policy will be expiring soon. Renew your policy now."
    },
    "Payment Details":{
        en:"Payment Details",
        bg:"[bg]Payment Details"
    },
    "Select payment option":{
        en:"Select payment option",
        bg:"[bg]Select payment option"
    },
    "Property Details": {
        en:"Property Details",
        bg:"[bg]Property Details"
    },
    "Cover Package": {
        en:"Cover Package",
        bg:"[bg]Cover Package"
    },
    "Add Ons": {
        en:"Add Ons",
        bg:"[bg]Add Ons"
    },
    "Property Owner": {
        en:"Property Owner",
        bg:"[bg]Property Owner"
    },
    "Property Address":{
        en:"Property Address",
        bg:"[bg]Property Address"
    },
    "Beneficiary":{
        en:"Beneficiary",
        bg:"[bg]Beneficiary"
    },
    "Children":{
        en:"Children",
        bg:"[bg]Children"
    },
    "Adults":{
        en:"Adults",
        bg:"[bg]Adults"
    },
    "Elders":{
        en:"Elders",
        bg:"[bg]Elders"
    },
    "16 to 65 years old":{
        en:"16 to 65 years old",
        bg:"[bg]16 to 65 years old"
    },
    "65 to 70 years old":{
        en:"65 to 70 years old",
        bg:"[bg]65 to 70 years old"
    },
    "Send to email":{
        en:"Send to email",
        bg:"[bg]Send to email"
    },
    "Payment of Instalments": {
        en:"Payment of Instalments",
        bg:"[bg]Payment of Instalments"       
    },
    "Go to":{
        en:"Go to",
        bg:"[bg]Go to"
    },
    "Personal Details":{
        en:"Personal Details",
        bg:"[bg]Personal Details"   
    },
    "Company Name":{
        en:"Company Name",
        bg:"[bg]Company Name"  
    },
    "Full Name":{
        en:"Full Name",
        bg:"[bg]Full Name"  
    },
    "Company Name in English":{
        en:"Company Name in English",
        bg:"[bg]Company Name in English"  
    },
    "Name in English":{
        en:"Name in English",
        bg:"[bg]Name in English"  
    },
    "Representative LNCH":{
        en:"Representative LNCH",
        bg:"[bg]Representative LNCH"
    },
    "Representative EGN":{
        en:"Representative EGN",
        bg:"[bg]Representative EGN"
    },
    "Contact Person LNCH":{
        en:"Contact Person LNCH",
        bg:"[bg]Contact Person LNCH"
    },
    "Contact Person EGN":{
        en:"Contact Person EGN",
        bg:"[bg]Contact Person EGN"
    },
    "If you are not the card holder you will be asked to sign the policy with electronic signature!.":{
        en:"If you are not the card holder you will be asked to sign the policy with electronic signature!.",
        bg:"[bg]If you are not the card holder you will be asked to sign the policy with electronic signature!."
    },
    "e-Signature Notice": {
        en:"e-Signature Notice",
        bg:"[bg]e-Signature Notice"
    },
    "Are you sure want to delete this draft?":{
        en:"Are you sure want to delete this draft?",
        bg:"[bg]Are you sure want to delete this draft?"        
    },
    "Your Password has been changed successfully...!":{
        en:"Your Password has been changed successfully...!",
        bg:"[bg]Your Password has been changed successfully...!"        
    },
    "The EGN you entered in the insuring party is not identical to your profile. You can continue as a guest or login and loose your progress.": {
        en:"The EGN you entered in the insuring party is not identical to your profile. You can continue as a guest or login and loose your progress.",
        bg:"[bg]The EGN you entered in the insuring party is not identical to your profile. You can continue as a guest or login and loose your progress."  
    },
    "Entered Details Successfully Updated":{
        en:"Entered Details Successfully Updated",
        bg:"[bg]Entered Details Successfully Updated"        
    },
    "Payment Gateway under progress": {
        en:"Payment Gateway under progress",
        bg:"[bg]Payment Gateway under progress"      
    },
    "MTPL Calculator": {
        en: "MTPL Calculator",
        bg: "[bg]MTPL Calculator"
    },
    "Purchase MTPL Policy": {
        en: "Purchase MTPL Policy",
        bg: "[bg]Purchase MTPL Policy"
    },
    "Property Calculator":{
        en:"Property Calculator",
        bg:"[bg]Property Calculator"
    },
    "Purchase Property Policy":{
        en:"Purchase Property Policy",
        bg:"[bg]Purchase Property Policy"
    },
    "Renew Policy":{
        en:"Renew Policy",
        bg:"[bg]Renew Policy"
    },
    "Yearly":{
        en:"Yearly",
        bg:"[bg]Yearly"
    },
    "Every 6 months":{
        en:"Every 6 months",
        bg:"[bg]Every 6 months"
    },
    "Every 3 months":{
        en:"Every 3 months",
        bg:"[bg]Every 3 months"
    },
    "Monthly":{
        en:"Monthly",
        bg:"[bg]Monthly"
    },
    "Add person":{
        en:"Add Person",
        bg:"[bg]Add Person"
    },
    "Remove person":{
        en:"Remove Person",
        bg:"[bg]Remove Person"
    },
    "per instalment":{
        en:"per instalment",
        bg:"[bg]per instalment"
    },
    "Buildings that are under construction or rough construction, those that are not put into regular operation":{
        en:"Buildings that are under construction or rough construction, those that are not put into regular operation",
        bg:"[bg]Buildings that are under construction or rough construction, those that are not put into regular operation"
    },
    "Buildings with awning, including vans, caravans, tents":{
        en:"Buildings with awning, including vans, caravans, tents",
        bg:"[bg]Buildings with awning, including vans, caravans, tents"
    },
    "Sites with Production and Economic purpose, Farm and Agricultural buildings, Goods, Materials and Agricultural Products":{
        en:"Sites with Production and Economic purpose, Farm and Agricultural buildings, Goods, Materials and Agricultural Products",
        bg:"[bg]Sites with Production and Economic purpose, Farm and Agricultural buildings, Goods, Materials and Agricultural Products"
    },
    "Movable property stored in basements, attics":{
        en:"Movable property stored in basements, attics",
        bg:"[bg]Movable property stored in basements, attics"
    },
    "Documents, Cash, Photographs, Precious Metals, Precious Stones, Objects of Artistic value, Historical, philatelic and numismatic value, Antiques; Intellectual Property Products":{
        en:"Documents, Cash, Photographs, Precious Metals, Precious Stones, Objects of Artistic value, Historical, philatelic and numismatic value, Antiques; Intellectual Property Products",
        bg:"[bg]Documents, Cash, Photographs, Precious Metals, Precious Stones, Objects of Artistic value, Historical, philatelic and numismatic value, Antiques; Intellectual Property Products"
    },
    "Weapons, Ammunition, Explosives, Narcotics and Opiates, all kinds of substances prohibited by law, etc. specified in the GTC":{
        en:"Weapons, Ammunition, Explosives, Narcotics and Opiates, all kinds of substances prohibited by law, etc. specified in the GTC",
        bg:"[bg]Weapons, Ammunition, Explosives, Narcotics and Opiates, all kinds of substances prohibited by law, etc. specified in the GTC"
    },
    "Sorry for the inconvenience, we are unable to find a suitable payment option for your travel.":{
        en:"Sorry for the inconvenience, we are unable to find a suitable payment option for your travel.",
        bg:"[bg]Sorry for the inconvenience, we are unable to find a suitable payment option for your travel."
    },
    "No Price Details Option Available":{
        en:"No Price Details Option Available",
        bg:"[bg]No Price Details Option Available"
    },
    "removing":{
        en:"removing",
        bg:"[bg]removing"
    },
    "adding":{
        en:"adding",
        bg:"[bg]adding"
    },
    "Try Again":{
        en:"Try Again",
        bg:"[bg]Try Again"
    },
    "Available in":{
        en:"Available in",
        bg:"[bg]Available in"
    },
    "Apartment":{
        en:"Apartment",
        bg:"[bg]Apartment"
    },
    "House":{
        en:"House",
        bg:"[bg]House"
    },
    "Villa":{
        en:"Villa",
        bg:"[bg]Villa"
    },
    "Insured Person":{
        en:"Insured Person",
        bg:"[bg]Insured Person"
    },
    "Contact Us":{
        en:"Contact Us",
        bg:"[bg]Contact Us"
    },
    "Upload Image":{
        en:"Upload Image",
        bg:"[bg]Upload Image"
    },
    "Link Expired":{
        en:"Link Expired",
        bg:"[bg]Link Expired"
    },
    "No Data Found":{
        en:"No Data Found",
        bg:"[bg]No Data Found"
    },
    "Well, that’s awkward...":{
        en:"Well, that’s awkward...",
        bg:"[bg]Well, that’s awkward..."
    },
    "Leased Vehicles":{
        en:"Leased Vehicles",
        bg:"[bg]Leased Vehicles"
    },
    "Invalid Insuring party":{
        en:"Invalid Insuring party",
        bg:"[bg]Invalid Insuring party"
    },
    "No Instalment Option Available":{
        en:"No Instalment Option Available",
        bg:"[bg]No Instalment Option Available"
    },
    "Something Went Wrong!":{
        en:"Something Went Wrong!",
        bg:"[bg]Something Went Wrong!"
    },
    "The Link to your proposal has expired":{
        en:"The Link to your proposal has expired",
        bg:"[bg]The Link to your proposal has expired"
    },
    "Its Not a valid link.":{
        en:"Its Not a valid link.",
        bg:"[bg]Its Not a valid link."
    },
    "The Link to your summary has expired":{
        en:"The Link to your summary has expired",
        bg:"[bg]The Link to your summary has expired"
    },
    "Single payment":{
        en:"Single payment",
        bg:"[bg]Single payment" 
    },
    "Two payments":{
        en:"Two payments",
        bg:"[bg]Two payments" 
    },
    "Four payments":{
        en:"Four payments",
        bg:"[bg]Four payments" 
    },
    "First instalment":{
        en:"First instalment",
        bg:"[bg]First instalment"      
    },
    "Second instalment":{
        en:"Second instalment",
        bg:"[bg]Second instalment"      
    },
    "Third instalment":{
        en:"Third instalment",
        bg:"[bg]Third instalment"      
    },
    "Fourth instalment":{
        en:"Fourth instalment",
        bg:"[bg]Fourth instalment"      
    },
    "For leased vehicles no offer can be submitted online. The offer may be received at DZI office":{
        en:"For leased vehicles no offer can be submitted online. The offer may be received at DZI office",
        bg:"[bg]For leased vehicles no offer can be submitted online. The offer may be received at DZI office" 
    },
    "Casco has an active policy for the same vehicle with different data. The change in the data will be reflected in an annex. The annex will be sent to you by courier / email or will be provided for signing by e-signature.":{
        en:"Casco has an active policy for the same vehicle with different data. The change in the data will be reflected in an annex. The annex will be sent to you by courier / email or will be provided for signing by e-signature.",
        bg:"[bg]Casco has an active policy for the same vehicle with different data. The change in the data will be reflected in an annex. The annex will be sent to you by courier / email or will be provided for signing by e-signature"
    },
    "Something went wrong and we cannot proceed with the process.Please try again later.":{
        en:"Something went wrong and we cannot proceed with the process.Please try again later.",
        bg:"[bg]Something went wrong and we cannot proceed with the process.Please try again later."  
    },
    "Go to Forgot Password":{
        en:"Go to Forgot Password",
        bg:"[bg]Go to Forgot Password"
    },
    "Create a new policy":{
        en:"Create a new policy",
        bg:"[bg]Create a new policy"
    },
    "Try a different Vehicle":{
        en:"Try a different Vehicle",
        bg:"[bg]Try a different Vehicle"
    },
    "Go to dashboard":{
        en:"Go to dashboard",
        bg:"[bg]Go to dashboard"
    },
    "Remove":{
        en:"Remove",
        bg:"[bg]Remove"
    },
    "This draft will expire on":{
        en:"This draft will expire on",
        bg:"[bg]This draft will expire on"
    },
    "Next installment due on":{
        en:"Next installment due on",
        bg:"[bg]Next installment due on"
    },
    "warning":{
        en:"warning",
        bg:"[bg]warning"
    },
    "informative":{
        en:"informative",
        bg:"[bg]informative"
    },
    "Invalid Owner Data":{
        en:"Invalid Owner Data",
        bg:"[bg]Invalid Owner Data" 
    },
    "Confirmation": {
        en:"Confirmation",
        bg:"[bg]Confirmation"    
    },
    "Annex Notice": {
        en:"Annex Notice",
        bg:"[bg]Annex Notice"   
    },
    "Sorry for the inconvenience, we are unable to find a suitable instalment option for your property.": {
        en:"Sorry for the inconvenience, we are unable to find a suitable instalment option for your property.",
        bg:"[bg]Sorry for the inconvenience, we are unable to find a suitable instalment option for your property."   
    },
    "Discrepancy in ENG":{
       en:"Discrepancy in ENG",
       bg:"[bg]Discrepancy in ENG"
    },
    "Discrepancy in EIK":{
        en:"Discrepancy in EIK",
        bg:"[bg]Discrepancy in EIK"
     },
     "Discrepancy in LNCH":{
        en:"Discrepancy in LNCH",
        bg:"[bg]Discrepancy in LNCH"
     },
     "404 - Page not found":{
         en:"404 - Page not found",
         bg:"[bg]404 - Page not found"
     },
     "Sorry! The page you were looking for doesn’t exist, isn’t available or was loading incorrectly.":{
         en:"Sorry! The page you were looking for doesn’t exist, isn’t available or was loading incorrectly.",
         bg:"[bg]Sorry! The page you were looking for doesn’t exist, isn’t available or was loading incorrectly."
     },
     "Back to dashboard":{
         en:"Back to dashboard",
         bg:"[bg]Back to dashboard"
     },
    "There are no due instalments for": {
        en:"There are no due instalments for",
        bg:"[bg]There are no due instalments for"  
    },
    "There is no Insurance Objects for you": {
        en:"There is no Insurance Objects for you",
        bg:"[bg]There is no Insurance Objects for you"
    },
    "No Payment of Instalment": {
        en:"No Payment of Instalment",
        bg:"[bg]No Payment of Instalment"
    },
    "There is no due or upcoming instalments for any of your active policies": {
        en:"There is no due or upcoming instalments for any of your active policies",
        bg:"[bg]There is no due or upcoming instalments for any of your active policies"
    },
    "Claim": {
        en: "Claim",
        bg: "[bg]Claim"
    },
    "Submit or check a": {
        en: "Submit or check a",
        bg: "[bg]Submit or check a"
    },

};
// Personal Data Protection Information
// Travel Insurance Document
// General Terms & Conditions
// General Terms & Conditions of the Travel insurance
// Road assistance document
// Property Home Insurance Document
// Property Offer